import { render, staticRenderFns } from "./order-status.vue?vue&type=template&id=2494926d"
import script from "./order-status.vue?vue&type=script&lang=js"
export * from "./order-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports